<template>
  <ContentPage back>
    <template #header>
      <div class="pl-2" style="font-size: 20px; font-weight: bold">Your Security Devices</div>
    </template>

    <div class="rounded-lg white">

      <v-data-table
        :headers="headers"
        :items="allDevices"
        :mobile-breakpoint="0"
        :loading="loading"
        hide-default-footer disable-pagination
      >
        <template #item.phone="{ item }">
          <v-icon small class="mr-1">mdi-phone</v-icon>
          {{ item.phone }}
        </template>
        
        <template #item.is_verified="{ item }">
          <v-icon v-if="item.is_verified" color="blue darken-1">mdi-check</v-icon>
        </template>
        
        <template #header.actions>
          <v-btn 
            fab x-small rounded dark
            class="ml-2" color="primary"
            :to="{ name: 'profile/wizard/step1' }"
          >
            <v-icon dark>mdi-plus</v-icon>
          </v-btn>
        </template>

        <template #item.actions="{ item }">
          <DeleteDialog
            v-if="item.is_verified"
            :device="item" 
            @reload="reload"
            @error="errorMessage"
          />

          <ActionsMenu
            v-else
            :device="item"
            @reload="reload"
            @error="errorMessage"
          />
        </template>
      </v-data-table>

      <div class="text-center pa-2 grey--text" style="font-size: 14px;">
        For your protection, you must have at least one<br>verified device to collect rewards.
      </div>
    </div>

    <ErrorOverlay
      title="Delete Error"
      v-model="error_dialog"
      :loading="loading"
    >
      {{ error_message }}
    </ErrorOverlay>
  </ContentPage>
</template>

<script>
import ActionsMenu from './ActionsMenu'
import { ContentPage } from '@/components/pages'
import DeleteDialog from './DeleteDialog'
import { mapActions, mapGetters } from 'vuex'
import ErrorOverlayMixin from '@/lib/mixins/ErrorOverlay'

export default {
  name: 'ProfileDevicesView',

  mixins: [ ErrorOverlayMixin ],

  components: { ActionsMenu, ContentPage, DeleteDialog },

  data: () => ({
    loading: false,

    headers: [
      {
        text: 'Phone', value: 'phone',
        sortable: false,
        class: 'pl-2 pr-0', cellClass: 'pl-2 pr-0',
      },
      {
        text: 'Verified',
        value: 'is_verified',
        align: 'center',
        sortable: false,
        class: 'px-1', cellClass: 'px-1 text-no-wrap',
      },
      {
        value: 'actions',
        align: 'center',
        sortable: false,
        width: "1%",
        class: 'pl-1 pr-2', cellClass: 'pl-1 pr-2 text-no-wrap'
      },
    ]
  }),
  
  computed: {
    ...mapGetters('devices', ['allDevices']),
  },
  
  methods: {
    ...mapActions('devices', ['loadAll']),

    errorMessage(error) {
      this.error_dialog = true
      this.error_message = error
    },
  
    async reload() {
      this.loading = true
      const result = await this.loadAll()
      this.loading = false

      if(!result.ok) {
        this.errorMessage(result.error)
      }
    },
  },

  async created() {
    this.reload()
  },
}
</script>